import { useEffect, useRef, useState } from 'react';
import { downloadBase64AsPDF } from '@ibk/shared-utils';
import { useGenerateEmissorOrderReceiptPdfMutation, } from '../services/contractOrderReceiptApi';
export function useEmissorOrderReceiptPdf(scopeKey = '') {
    const [trigger] = useGenerateEmissorOrderReceiptPdfMutation();
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const inFlight = useRef(false);
    const mounted = useRef(true);
    const activeRequest = useRef(null);
    const generation = useRef(0);
    useEffect(() => {
        mounted.current = true;
        setIsError(false);
        setIsLoading(false);
        inFlight.current = false;
        return () => {
            mounted.current = false;
            generation.current += 1;
            activeRequest.current?.abort();
        };
    }, [scopeKey]);
    async function viewReceipt(params, filename) {
        if (inFlight.current || !params.contractId || !params.orderId) {
            return;
        }
        inFlight.current = true;
        setIsError(false);
        setIsLoading(true);
        const currentGeneration = generation.current;
        try {
            const request = trigger(params);
            activeRequest.current = request;
            const receipt = await request.unwrap();
            if (!mounted.current || currentGeneration !== generation.current)
                return;
            if (!receipt.base64) {
                throw new Error('Empty payment receipt');
            }
            downloadBase64AsPDF(receipt.base64, filename);
        }
        catch {
            if (mounted.current && currentGeneration === generation.current)
                setIsError(true);
        }
        finally {
            if (currentGeneration === generation.current) {
                inFlight.current = false;
                activeRequest.current = null;
                if (mounted.current)
                    setIsLoading(false);
            }
        }
    }
    return { viewReceipt, isError, isLoading, clearError: () => setIsError(false) };
}
